<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" i18n="@@customRemarkTitle" id="modal-header">Custom Remarks</h3>
    <button
      type="button"
      class="close"
      aria-label="Custom Remark Modal Close"
      ngbAutoFocus
      [disabled]="addingRemark"
      (click)="close()"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body" id="remark-message">
    <!-- Loaded Remarks for this basket -->
    <div class="saved-remarks">
      @if (loadingSavedRemarks) {
        <div>Loading Saved Remarks...</div>
      }
      @if (!loadingSavedRemarks) {
        <div class="flex-column-container">
          @for (remark of customRemarks; track remark) {
            <div class="flex-column-container">
              <div class="remark-text">
                {{ remark.remarkType | remarkFormat | titlecase }}&nbsp;{{ remark.text }}
              </div>
              <div class="remark-foot">
                Added on {{ remark.createdAt | sabsDate }} by {{ remark.agent.email }}
                <hr />
              </div>
            </div>
          }
        </div>
      }
    </div>

    <div>
      @if (!remarks.length && !loadingRemarks) {
        <div class="error">No remarks found.</div>
      }
      @if (!loadingRemarks && remarks.length) {
        <select
          [disabled]="addingRemark"
          appSelect
          [border]="true"
          [noIcon]="true"
          [(ngModel)]="chosenRemark"
        >
          @for (remark of remarks; track remark) {
            <option [value]="remark.value">{{ remark.label }}</option>
          }
        </select>
      }
      <div class="text-input">
        <textarea
          [disabled]="addingRemark"
          class="remark-text-box"
          style="width: 100%"
          [(ngModel)]="text"
          maxlength="5000"
        >
        </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      id="button_ok"
      appButton="small"
      aria-label="Add Remark"
      (click)="addRemark()"
      [disabled]="!chosenRemark || !text || addingRemark"
    >
      @if (!addingRemark) {
        <span i18n="@@addremark">Add Remark</span>
      }
      @if (addingRemark) {
        <span>
          <fa-icon class="" [icon]="['fas', 'spinner-third']" [spin]="true"> </fa-icon>
        </span>
      }
    </button>
    <button
      type="button"
      appButton="small"
      class="small-button--no"
      [disabled]="addingRemark"
      (click)="close()"
      i18n="@@closeDialog"
    >
      Close
    </button>
  </div>
</div>
